(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tab-item"] && !Shopify.designMode) return;
  try {
    class TabItem extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-tab-button]');
    this.panel = this.querySelector('[data-tab-panel]');
    this.tabsContainer = this.closest('tabs-container');
    
    if (!this.tabsContainer) return;
    
    // Move button to header
    const header = this.tabsContainer.querySelector('.tabs__header');
    if (header && this.button) {
      header.appendChild(this.button);
    }
    
    // Setup click handler
    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }
    
    // Check for slider - now responsive
    this.hasSlider = this.panel && this.panel.hasAttribute('data-slider');
    this.hasMobileSlider = this.panel && this.panel.hasAttribute('data-mobile-slider');
    this.sliderInitialized = false;
    
    // Check if this is the first tab or has active-by-default attribute
    if (this.hasAttribute('active-by-default') || this.isFirstTab()) {
      setTimeout(() => {
        this.activate();
        // Initialize slider based on screen size
        if (this.shouldShowSlider() && !this.sliderInitialized) {
          this.initSlider();
          this.sliderInitialized = true;
        }
      }, 50);
    }
    
    // Handle window resize for mobile slider
    this.resizeHandler = () => this.handleMobileSliderResize();
    window.addEventListener('resize', this.resizeHandler);
  }
  
  disconnectedCallback() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }
  
  shouldShowSlider() {
    if (this.hasSlider) return true;
    if (this.hasMobileSlider && window.innerWidth <= 749) return true;
    return false;
  }
  
  handleMobileSliderResize() {
    const shouldShow = this.shouldShowSlider();
    const isActive = this.panel && this.panel.classList.contains('tab-panel--active');
    
    if (shouldShow && !this.sliderInitialized && isActive) {
      this.initSlider();
      this.sliderInitialized = true;
    } else if (!shouldShow && this.sliderInitialized) {
      this.destroySlider();
      this.sliderInitialized = false;
    } else if (shouldShow && this.sliderInitialized) {
      // Update layout on resize
      this.updateSliderLayout();
    }
  }
  
  isFirstTab() {
    const allTabs = this.tabsContainer.querySelectorAll('tab-item');
    return allTabs[0] === this;
  }
  
  handleClick() {
    const allTabs = this.tabsContainer.querySelectorAll('tab-item');
    const allButtons = this.tabsContainer.querySelectorAll('[data-tab-button]');
    
    allTabs.forEach(tab => {
      const pnl = tab.querySelector('[data-tab-panel]');
      if (pnl) {
        pnl.classList.remove('tab-panel--active');
        pnl.style.display = 'none';
      }
      if (tab.sliderInitialized) {
        tab.destroySlider();
        tab.sliderInitialized = false;
      }
    });
    
    allButtons.forEach(btn => {
      btn.classList.remove('tabs__button--active');
    });
    
    this.activate();
    
    if (this.shouldShowSlider() && !this.sliderInitialized) {
      setTimeout(() => {
        this.initSlider();
        this.sliderInitialized = true;
        console.log('clciked');
      }, 100);
    }
  }
  
  activate() {
    if (this.button) {
      this.button.classList.add('tabs__button--active');
    }
    if (this.panel) {
      this.panel.classList.add('tab-panel--active');
      this.panel.style.display = 'block';
    }
  }
  
  destroySlider() {
    if (!this.panel) return;
    
    const track = this.panel.querySelector('.slider-track');
    if (!track || !this.originalCards) return;
    
    // Remove slider elements
    const nav = this.panel.querySelectorAll('.slider-nav');
    const dots = this.panel.querySelector('.slider-dots');
    nav.forEach(n => n.remove());
    if (dots) dots.remove();
    
    // Restore original cards
    this.panel.innerHTML = '';
    this.panel.style.overflow = '';
    this.originalCards.forEach(card => {
      card.style.width = '';
      card.style.marginRight = '';
      card.style.flexShrink = '';
      this.panel.appendChild(card);
    });
    
    // Clear autoplay
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
  
  initSlider() {
    setTimeout(() => {
      const cards = this.panel.querySelectorAll('.image-card');
      
      if (cards.length === 0) {
        console.warn('TabItem: No image cards found for slider');
        return;
      }
      
      if (this.panel.querySelector('.slider-track')) {
        return;
      }
      
      this.originalCards = Array.from(cards);
      
      // Get slider settings with mobile-specific defaults
      if (this.hasMobileSlider && !this.hasSlider) {
        // Mobile-only slider: 1 item at a time on mobile
        this.sliderColsDesktop = parseInt(this.panel.getAttribute('data-slider-cols-desktop')) || 3;
        this.sliderColsTablet = parseInt(this.panel.getAttribute('data-slider-cols-tablet')) || 2;
        this.sliderColsMobile = 1; // Show 1 item at a time on mobile
      } else {
        this.sliderColsDesktop = parseInt(this.panel.getAttribute('data-slider-cols-desktop')) || 3;
        this.sliderColsTablet = parseInt(this.panel.getAttribute('data-slider-cols-tablet')) || 2;
        this.sliderColsMobile = parseInt(this.panel.getAttribute('data-slider-cols-mobile')) || 1;
      }
      
      this.sliderGap = parseInt(this.panel.getAttribute('data-slider-gap')) || 0;
      
      // Add overflow hidden to panel
      this.panel.style.overflow = 'hidden';
      this.panel.style.position = 'relative';
      
      const track = document.createElement('div');
      track.className = 'slider-track';
      track.style.display = 'flex';
      track.style.transition = 'transform 0.3s ease';
      track.style.gap = `${this.sliderGap}px`;
      
      cards.forEach(card => {
        track.appendChild(card);
      });
      
      this.panel.innerHTML = '';
      this.panel.appendChild(track);
      
      this.currentSlide = 0;
      this.totalSlides = cards.length;
      
      this.createSliderNav();
      this.updateSliderLayout();
      
      const autoplay = this.panel.getAttribute('data-autoplay') === 'true';
      const autoplaySpeed = parseInt(this.panel.getAttribute('data-autoplay-speed')) || 5000;
      
      if (autoplay) {
        this.startAutoplay(autoplaySpeed);
      }
      
    }, 150);
  }
  
  createSliderNav() {
    const prevBtn = document.createElement('button');
    prevBtn.className = 'slider-nav slider-nav--prev';
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    prevBtn.addEventListener('click', () => this.prevSlide());
    
    const nextBtn = document.createElement('button');
    nextBtn.className = 'slider-nav slider-nav--next';
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    nextBtn.addEventListener('click', () => this.nextSlide());
    
    this.panel.appendChild(prevBtn);
    this.panel.appendChild(nextBtn);
    
    this.createDots();
  }
  
  createDots() {
    const existingDots = this.panel.querySelector('.slider-dots');
    if (existingDots) {
      existingDots.remove();
    }
    
    const slidesPerView = this.getCurrentSlidesPerView();
    const totalDots = Math.ceil(this.totalSlides / slidesPerView);
    
    if (totalDots <= 1) return;
    
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'slider-dots';
    
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.className = 'slider-dot';
      if (i === 0) dot.classList.add('slider-dot--active');
      dot.addEventListener('click', () => this.goToSlide(i * slidesPerView));
      dotsContainer.appendChild(dot);
    }
    
    this.panel.appendChild(dotsContainer);
  }
  
  getCurrentSlidesPerView() {
    if (window.innerWidth <= 749) {
      return this.sliderColsMobile;
    } else if (window.innerWidth <= 989) {
      return this.sliderColsTablet;
    } else {
      return this.sliderColsDesktop;
    }
  }
  
  updateSliderLayout() {
    const slidesPerView = this.getCurrentSlidesPerView();
    const track = this.panel.querySelector('.slider-track');
    
    if (!track) return;
    
    const cards = track.querySelectorAll('.image-card');
    
    // Calculate proper width considering gap
    const gapTotalWidth = this.sliderGap * (slidesPerView - 1);
    const slideWidthPercent = 100 / slidesPerView;
    
    cards.forEach(card => {
      card.style.minWidth = `calc(${slideWidthPercent}% - 0px)`;
      card.style.maxWidth = `calc(${slideWidthPercent}% - 0px)`;
      card.style.width = `calc(${slideWidthPercent}% - 0px)`;
      card.style.flexShrink = '0';
    });
    
    this.createDots();
    
    const maxSlide = Math.max(0, this.totalSlides - slidesPerView);
    if (this.currentSlide > maxSlide) {
      this.currentSlide = maxSlide;
    }
    
    this.updateSliderPosition();
  }
  
  updateSliderPosition() {
    const track = this.panel.querySelector('.slider-track');
    const slidesPerView = this.getCurrentSlidesPerView();
    
    if (!track) return;
    
    // Calculate the width of one slide plus gap
    const cards = track.querySelectorAll('.image-card');
    if (cards.length === 0) return;
    
    const cardWidth = cards[0].offsetWidth;
    const translateX = this.currentSlide * (cardWidth + this.sliderGap);
    track.style.transform = `translateX(-${translateX}px)`;
    
    const dots = this.panel.querySelectorAll('.slider-dot');
    const activeDotIndex = Math.floor(this.currentSlide / slidesPerView);
    dots.forEach((dot, index) => {
      dot.classList.toggle('slider-dot--active', index === activeDotIndex);
    });
  }
  
  nextSlide() {
    const slidesPerView = this.getCurrentSlidesPerView();
    const maxSlide = Math.max(0, this.totalSlides - slidesPerView);
    
    // Move by 1 item instead of slidesPerView
    if (this.currentSlide < maxSlide) {
      this.currentSlide += 1;
    } else {
      this.currentSlide = 0;
    }
    this.updateSliderPosition();
  }
  
  prevSlide() {
    const slidesPerView = this.getCurrentSlidesPerView();
    const maxSlide = Math.max(0, this.totalSlides - slidesPerView);
    
    // Move by 1 item instead of slidesPerView
    if (this.currentSlide > 0) {
      this.currentSlide -= 1;
    } else {
      this.currentSlide = maxSlide;
    }
    this.updateSliderPosition();
  }
  
  goToSlide(slideIndex) {
    const slidesPerView = this.getCurrentSlidesPerView();
    const maxSlide = Math.max(0, this.totalSlides - slidesPerView);
    
    if (slideIndex >= 0 && slideIndex <= maxSlide) {
      this.currentSlide = slideIndex;
      this.updateSliderPosition();
    }
  }
  
  startAutoplay(speed) {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
    
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, speed);
  }
}

customElements.define('tab-item', TabItem);
  } catch(e) { console.error(e); }
})();

})();
